<template>
  <v-app>
    <appbarView v-if="!loading && showBars" />

    <v-main>
      <div id="app-wrapper" style="--v-layout-left: 0px; --v-layout-right: 0px;">
        <div id="app-inner">
          
          <v-fade-transition>
            <div v-if="loading" class="native-loader-overlay">
              <div class="pulse-container">
                <img src="https://mvexpress.mx/images/mvsimple.png" alt="MVExpress" class="pulsing-logo" />
                <h3 class="text-h6 font-weight-bold text-blue-darken-4 mt-6 text-center" style="line-height: 1.2;">
                  "Calidad en cada entrega,<br>valor en cada marca"
                </h3>
              </div>
            </div>
          </v-fade-transition>

          <div v-show="!loading">
            <router-view v-slot="{ Component }">
              <keep-alive :include="['MarcasXProductoView', 'PenafielView', 'Top10View', 'HomeView']">
                <component :is="Component" :key="route.name" />
              </keep-alive>
            </router-view>
          </div>

        </div>
      </div>
    </v-main>

    <BottomNavigation v-if="!loading && showBars" />
  </v-app>
</template>

<script setup>
import { provide, watch, onMounted, ref, computed } from "vue";
import { useRoute } from "vue-router";
import { createCartStore } from "./stores/cart";
import { useUserStore } from "@/stores/userStore"; // 👈 Recuperamos el store
import { useTimeStore } from "./stores/timestore";
import { TextZoom } from "@capacitor/text-zoom";
import appbarView from "@/components/appbar/appbarView.vue";
import BottomNavigation from "@/components/submenu/BottomNavigation.vue";

const loading = ref(true);
const timeStore = useTimeStore();
const cartStore = createCartStore();
provide("cartStore", cartStore);
const userStore = useUserStore(); // 👈 Instancia del store
const route = useRoute();

onMounted(async () => {
  console.log("🚀 App.vue mounted - Inicializando...");

  try {
    await TextZoom.set({ value: 1 });
  } catch (err) {
    console.warn("TextZoom no disponible");
  }

  try {
    // 1. Sincronizar hora
    try { await timeStore.syncServerTime(); } catch (e) {console.log(e)}

    // 2. Intervalos en segundo plano
    setInterval(() => timeStore.tick(), 1000);
    setInterval(() => timeStore.syncServerTime(), 5 * 60 * 1000);

    // 3. Restaurar sesión (SOLO SI NO ESTÁ LISTA)
    // Este IF evita que se cicle si la sesión ya existe
    if (typeof userStore.initSession === "function" && !userStore.isSessionReady) {
      await userStore.initSession();
    }

  } catch (e) {
    console.error("Error en inicialización:", e);
  } finally {
    // 4. Quitar loader
    loading.value = false;
  }
});

const showBars = computed(() => {
  const hiddenRoutes = ['Login', 'Register', 'login', 'register', 'Welcome', 'LoginHome', 'BootstrapView'];
  return userStore.isAuthenticated && route.name && !hiddenRoutes.includes(route.name);
});

watch(
  () => route.meta.title,
  (newTitle) => {
    document.title = newTitle || "MVExpress";
  },
  { immediate: true }
);
</script>

<style>
/* ... Tus estilos se quedan IGUAL, están perfectos ... */

.native-loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pulse-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pulsing-logo {
  width: 140px;
  height: auto;
  animation: nativePulse 1.5s ease-in-out infinite;
  filter: drop-shadow(0px 8px 16px rgba(13, 71, 161, 0.2));
}

@keyframes nativePulse {
  0% { transform: scale(0.95); opacity: 0.8; }
  50% { transform: scale(1.05); opacity: 1; }
  100% { transform: scale(0.95); opacity: 0.8; }
}

:root {
  --safe-area-top: env(safe-area-inset-top, 40px);
  --safe-area-bottom: env(safe-area-inset-bottom, 20px);
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

.v-app-bar {
  top: 0 !important;
  padding-top: var(--safe-area-top) !important;
  height: calc(64px + var(--safe-area-top)) !important;
  z-index: 1000 !important;
}

.v-toolbar__content {
  height: 64px !important;
}

.v-application {
  padding-top: 0;
  padding-bottom: var(--safe-area-bottom);
}

#app-wrapper {
  padding-left: env(safe-area-inset-left, 0);
  padding-right: env(safe-area-inset-right, 0);
  box-sizing: border-box;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.v-main {
  padding-top: calc(64px + var(--safe-area-top)) !important;
}

@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .fixed-bottom-nav {
    padding-bottom: max(env(safe-area-inset-bottom), 25px);
  }
}

/* =================================== */
/*  MEJORAS DE EXPERIENCIA NATIVA (UI) */
/* =================================== */
html, body, button, a, input, .v-btn, .v-list-item {
  touch-action: manipulation;
}
</style>